

/// <reference path="EventPhaseItem.ts" />

// Generated class EventPhaseLine_ManagedObject

class EventPhaseLine_ManagedObject extends EventPhaseItem
{
    // Relationship: section
    set section(value:EventPhaseSection) {
        this.setValueForKey(value, 'section');
    }
    get section():EventPhaseSection {
        return this.valueForKey('section') as EventPhaseSection;
    }
}
